export enum DeploymentProviders{
    Linode = "linode",
    Wasabi = "wasabi",
    Backblaze = "b2",
    Aws= "aws",
    StoreOne = "storone"
}